var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('div',{attrs:{"id":"nav"}},[_c('p',{staticClass:"text"},[_c('span',[_vm._v("欢迎访问CIIT网站")]),_vm._v(" | "),_c('span',[_vm._v(_vm._s(_vm.data))])])]),_c('div',{staticClass:"body"},[_c('Header'),_c('router-view')],1)]),_c('div',{staticClass:"footerBox"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }